"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-schedule/Event.ts